export default __webpack_public_path__ + "static/media/loan.bc36aab3.png";